import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IconName,
  IconPrefix,
  IconProp,
} from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { FontAwesomeService } from '../../../services/fontawesome.service';

@Component({
  selector: 'hdi-icon',
  imports: [CommonModule, FontAwesomeModule],
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class IconComponent implements OnChanges {
  @Input() size: Sizes = Sizes.MEDIUM;
  @Input() disabled: boolean = false;
  @Input() color?: Colors = Colors.BLACK;
  @Input() isHover: boolean = false;
  @Input() iconPrefix: string = 'fal';
  @Input() iconName: string = 'gear';

  public icon: IconProp = [
    this.iconPrefix as IconPrefix,
    this.iconName as IconName,
  ];

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly fontAwesomeService: FontAwesomeService
  ) {}

  ngOnChanges(): void {
    this.fontAwesomeService
      .loadIconPack(this.iconPrefix as IconPrefix)
      .then(() => {
        const isIconAvailable = this.fontAwesomeService.checkIconAvailable(
          this.iconPrefix,
          this.iconName
        );

        this.icon = isIconAvailable
          ? [this.iconPrefix as IconPrefix, this.iconName as IconName]
          : ['fal', 'gear'];

        this.cd.detectChanges();
      });
  }
}
